import React, { useState } from "react";

import Tooltip  from "@mui/material/Tooltip";
import {
  UserCircle,
  ChatCentered,
  DeviceMobile,
} from "@phosphor-icons/react";
import { connect } from "react-redux";
import {  } from "../../../../../Redux/Actions/actions";
import { Box, Stack } from "@mui/material";

const mapStateToProps = (state) => {
  const { contactListData } = state;
  return {
    externalChatData: contactListData.externalChatData,
  };
};



const UserDetails = (props) => {
  const { selectedCustomer } = props;
  const [Numbercopyed, setNumbercopyed] = useState("Copy");

  const name = (contact) => {
    if (!contact) return;
    console.log("contact", contact);
    return contact.username.slice(0, 1).toUpperCase();
  };

  return (
    <>
      <Box
        sx={{
          height: "130px",
          width: "100%",
          background: "#F6F7F9",
          borderRadius: "12px",
        }}
        p={1}
      >
        <Stack
          sx={{ height: "100%", width: "100%" }}
          direction={"row"}
          spacing={1}
        >
          <Stack spacing={0.1} alignItems={"center"}>
            <div
              style={{
                width: "80px",
                height: "80px",
                background: "#0B3363",
                display: "block",
                borderRadius: "50%",
                border: "2px solid white",
                boxShadow: "rgba(0, 0, 0, 0.4) 0px 8px 6px -3px inset",
              }}
            >
              <p
                className="chat_name my-auto h-100"
                style={{
                  textAlign: "center",
                  fontSize: "20px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <b
                  className="h-100 my-auto"
                  style={{
                    color: "#ffff",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "26px",
                    userSelect: "none",
                  }}
                >
                  {name(selectedCustomer)}
                </b>
              </p>
            </div>
          </Stack>

          <Stack spacing={0.5} sx={{ width: "100%" }}>
            <Stack direction={"row"} justifyContent={"end"}>
              {props.selectedCustomer ? (
                props.externalChatData.isvip ? (
                  <span
                    className="badge badge-pill bg-primary"
                    style={{ width: "30px" }}
                  >
                    VIP
                  </span>
                ) : (
                  <span
                    className="badge badge-pill bg-primary"
                    style={{ width: "70px" }}
                  >
                    Normal
                  </span>
                )
              ) : null}
            </Stack>

            <div
              className="CONTACT-LIST-AREA"
              style={{ width: "100%", overflowY: "scroll", cursor: "pointer" }}
            >
              <div className="w-100 d-flex ">
                <span>
                  <UserCircle size={18} cursor={"pointer"} weight="bold" />
                </span>
                <span
                  className="mx-1 text-truncate w-100"
                  style={{ fontSize: "12px" }}
                >
                  {selectedCustomer
                    ? selectedCustomer.username
                      ? selectedCustomer.username
                      : selectedCustomer.phonenumber
                    : ""}
                </span>
              </div>

              <div className="w-100 d-flex">
                <span>
                  <ChatCentered size={18} cursor={"pointer"} weight="bold" />
                </span>
                <span
                  className="mx-1 text-truncate w-100"
                  style={{ fontSize: "12px" }}
                >
                  {selectedCustomer
                    ? selectedCustomer.email
                      ? selectedCustomer.email
                      : "NA"
                    : "NA"}
                </span>
              </div>

              <div className="w-100 d-flex">
                <span>
                  <DeviceMobile size={18} cursor={"pointer"} weight="bold" />
                </span>
                <span className="mx-1 text-truncate">
                  <Tooltip
                    title={Numbercopyed}
                    arrow
                    placement="right"
                  >
                    <span
                      className="w-100 text-break"
                      onClick={() => {
                        navigator.clipboard.writeText(props.selectedmobile);
                        setNumbercopyed("Copied");
                        setTimeout(() => {
                          setNumbercopyed("Copy");
                        }, 3000);
                      }}
                      style={{ cursor: "pointer", fontSize: "12px" }}
                    >
                      {selectedCustomer
                        ? selectedCustomer.phonenumber
                          ? selectedCustomer.phonenumber
                          : "NA"
                        : "NA"}
                    </span>
                  </Tooltip>
                </span>
              </div>
            </div>
          </Stack>
        </Stack>
      </Box>
    </>
  );
};

export default connect(mapStateToProps, {
})(UserDetails);
